import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../../common/util/redux';
import {MyPageSortKeyByTab} from '../type';

export interface IStateMyPage {
  sortKeyByTab: MyPageSortKeyByTab;
}

const INITIAL_STATE: IStateMyPage = {
  sortKeyByTab: {
    recent: undefined,
    like: undefined,
    own: undefined,
  },
};

export default createReducer<IStateMyPage, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
    }),
  }
);
